import { isEmpty } from 'lodash';
import { saveSession } from '../session';
import { CheckoutState } from '../state/index';
import { redirectTo } from './browser';

// This is a super hack!! redirected payments strip out any request parameters other than eid. when doing branch testing ie using version this takes us out of the branch we want to test. this function refreshes the page and appends the version param if we are redirected from an external payment.
export const refreshAndAppendVersionParamIfRedirectedFromExternalPaymentAndBranchTesting =
    async (
        initialState: CheckoutState,
        isProd: (domain: string) => boolean,
    ): Promise<void> => {
        if (isEmpty(initialState)) {
            return;
        }

        const ebDomain = initialState?.app?.ebDomain;

        if (isProd(ebDomain || '')) {
            return;
        }

        const currentUrl = new URL(window.location.href);
        const urlVersionParam = currentUrl.searchParams.get('version');
        if (urlVersionParam) {
            return;
        }

        const requestParams = initialState?.app?.request?.params;
        const version = requestParams?.version;

        if (version) {
            saveSession(initialState);
            const url = new URL(window.location.href);
            url.searchParams.set('version', version);
            await redirectTo(url.toString());
        }
    };
